import Image from 'components/Common/Image'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { LoyaltyLandingPageTileDetails } from '../LoyaltyLandingPageData'
import { mediaQueryUp } from 'components/utils/breakpoint'

const SmallTile = styled.div`
  display: grid;
  grid-template: 1fr / ${rem(100)} auto;
  gap: ${rem(16)};

  ${mediaQueryUp.tablet} {
    grid-template: ${rem(160)} auto / 1fr;
  }
`

interface Props {
  tile: LoyaltyLandingPageTileDetails;
}

function LoyaltyLandingPageSmallTile(props: Props) {
  const { tile } = props
  return <SmallTile key={tile.title}>
    <Image image={tile.image} height={160} dpr={2} fit="center" />
    <VerticalSpacer gap={8}>
      <Heading variant="heading4">{tile.title}</Heading>
      <BodyText variant="medium">{tile.description}</BodyText>
    </VerticalSpacer>
  </SmallTile>
}

export default LoyaltyLandingPageSmallTile
